<template>
  <div class="wx-invite">
    <div class="notice">
      <img src="../../../assets/notice.png" alt="" style="width: 16px; height: 16px; margin-right: 4px">
      <div class="info">{{ team.name }} 邀请您加入队伍，填写信息后，保存即刻入队</div>
    </div>
    <div style="padding: 16px 16px 0 16px;">
      <div class="project">
        <div class="top">
          <div class="left">
            <div class="group">
              <span class="entryType" v-if="project.publicSignUp === 0 && project.allowTeamSignup === 1">邀请</span>
              <span class="group-name"> {{ project.group }}</span>
            </div>
            <div class="row">
              <div class="base-box" style="margin-right: 6px">
                <span v-if="project.unitType === 0" style="font-size: 12px; color: #FF652A;">队</span>
                <span v-else-if="project.unitType === 1" style="font-size: 12px; color: #FF652A;">人</span>
                <span v-else style="font-size: 12px; color: #FF652A;">多</span>
              </div>
              <div class="base-box" v-if="project.genderLimit == 1" style="margin-right: 6px">
                <img src="../../../assets/boy.png" style="width: 20px; height: 20px;">
              </div>
              <div class="base-box" v-else-if="project.genderLimit == 2" style="margin-right: 6px">
                <img src="../../../assets/girl.png" style="width: 20px; height: 20px;">
              </div>
              <div class="base-box" v-else-if="project.genderLimit == 0" style="margin-right: 6px; width: 34px;">
                <span style="font-size: 12px; color: #FF652A;">男/女</span>
              </div>
              <div class="base-box" v-else-if="project.genderLimit == 3" style="margin-right: 6px; width: 30px;">
                <span style="font-size: 12px; color: #FF652A;">不限</span>
              </div>
              <div class="info">
                参赛年龄：
                <span v-if="project.isOpenAgeLimit === 1">
                  {{ getFormatDate(project.maxAge) }}
                  {{ project.maxAge && project.minAge ? '~' : '' }}
                  {{ getFormatDate(project.minAge) }}
                </span>
                <span v-else>不限</span>
              </div>
            </div>
            <div class="row">
              <div class="info">选手人数：{{ project.teamMemberLeastCount }} ～ {{ project.teamMemberLimitCount }}</div>
            </div>
            <div v-if="project.isOpenCharge === 1">
              <div class="row">
                <div class="info">收费说明：{{ project.feeDescription }}</div>
              </div>
              <div class="row">
                <div class="info">收费方式：{{ getFeeMethodsLabel(project.feeMethod) }}</div>
              </div>
            </div>
          </div>
          <!--          <div class="right">-->
          <!--            <img src="../../../assets/right.png" style="width: 16px; height: 16px;" alt="">-->
          <!--          </div>-->
        </div>
        <div class="line"></div>
        <div class="bottom1">
          <div class="row">
            <div style="display: flex">
              <div class="col" v-if="project.isOpenCharge === 1 && project.feeMethod !== 0" style="margin-right: 8px;">
                <div class="icon">费</div>
                <div class="price">
                  <span v-if="project.feeAmount"> ¥{{ (project.feeAmount / 100).toFixed(2) }}</span>
                  <span v-else>¥0.00</span>
                </div>
              </div>
              <!--              <div class="col">-->
              <!--                <div class="icon">押</div>-->
              <!--                <div class="price" >-->
              <!--                  <span v-if="project.deposit">¥{{ (project.deposit / 100).toFixed(2) }}</span>-->
              <!--                  <span v-else>¥0.00</span>-->
              <!--                </div>-->
              <!--              </div>-->
            </div>
            <div class="col">
              <div class="num" v-if="project.isOpenTeamLimit === 1">剩余名额：{{ project.teamLimitCount - project.teamCount >=
                0 ? (project.teamLimitCount - project.teamCount) : 0 }}队</div>
              <div class="num" v-else>不限</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PlayerForm 
      ref="playerForm"
      :form.sync="player"
      :player-signup-fields="psfs"
      :jerseys-size-fields="project.jerseysSizeFields"
      :jerseys-size-accessory="project.jerseysSizeAccessory"
      :player-number-range="project.playerNumberRange"
      :cert-type-columns="certTypeColumns"
      :player-signup-fields-label="playerSignupFieldsLabel"
      :sport-type="project.sportType"
      :max-age="project.maxAge"
      :min-age="project.minAge"
      :qiniu-token="qiniuToken"
      :gender-limit="project.genderLimit"
      :custom-text-options="project.customTextOptions"
    />
    <div style="height: 80px;"></div>
    <div class="bottom">
      <div @click="showAgreementFun" v-if="project.isUseAgreement === 1 && agreementList.length > 0"
        style="display: flex; justify-content: center; padding: 0 0 8px 0">
        <van-checkbox disabled v-model="allow" shape="square" icon-size="16px">
          <span style="font-size: 13px; color: #8C8C8C">报名前请先同意</span>
          <span v-for="item in agreementList" :key="item.id" style="color: #409EFF; font-size: 13px;">《{{ item.title
          }}》</span>
        </van-checkbox>
      </div>
      <van-button type="info" round block @click="savePlayer" style="height: 50px; background-color: #191919;">
        <span style="color: #FFFFFF;">保 存</span>
      </van-button>
    </div>
    <div class="popup">
      <van-popup v-model="showBirthday" position="bottom" :style="{ height: '50%' }">
        <van-datetime-picker v-model="currentDate" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate"
          @cancel="cancelBirthdayTime" @confirm="confirmBirthdayTime" />
      </van-popup>
      <van-popup v-model="showCertType" position="bottom" :style="{ height: '50%' }">
        <van-picker title="请选择证件类型" show-toolbar :columns="certTypeColumns" value-key="label" @confirm="onConfirmCertType"
          @cancel="onCancelCertType" />
      </van-popup>
      <van-popup v-model="showArea" round position="bottom">
        <van-cascader v-model="player.domicileAreaId" :title="`请选择${playerSignupFieldsLabel.domicileAreaId || '所在地区'}`" :options="options" :field-names="fieldNames"
          @close="showArea = false" @change="onChange" @finish="onFinish" />
      </van-popup>
      <van-popup v-model="showAgreement" position="bottom" round :style="{ height: '70%' }">
        <div id="agreement"></div>
        <div style="height: 115px;"></div>
        <div class="bottom">
          <van-button type="info" block @click="allowAgreement"
            style="background-color: #191919; color: #FFFFFF; height: 50px; border-radius: 25px">同意条款</van-button>
        </div>
      </van-popup>
    </div>
    <van-dialog v-model="showDialog" title="报名提交成功" @confirm="goEntryList" confirm-button-text="我的参赛" theme="round-button"
      confirm-button-color="darkblue">
      <div style="font-size: 13px; color: #333333; padding: 12px 20px 10px 20px">
        <span style="display: inline-block; font-size: 13px; width: 2em;"></span>
        报名提交成功，您可以前往我的参赛列表查看报名进度
      </div>
    </van-dialog>
    <van-popup v-model="showSite" round position="bottom" :style="{ height: '50%' }">
      <van-picker title="请选择位置" show-toolbar :columns="siteList"
        @confirm="(e) => { player.position = e, showSite = false }" @cancel="showSite = false" />
    </van-popup>
  </div>
</template>

<script>
import { DateUtil, QNImageUtil, RegExpr, ToolUtil } from "@/utils";
import Vue from 'vue'
import {
  Form, Field, Icon, Popup, Loading, Overlay, Dialog, Uploader,
  RadioGroup, Radio, DatetimePicker, Button, Picker, Toast, Cascader,
  Checkbox, CheckboxGroup
} from "vant";
import {
  createBMMatchTeamPlayer,
  getAreaTreeList,
  getBMMatchTeamSignup,
  bangsaishiCreatePlayerSignupOrder
} from "@/api/match";
import { getQiniuUploadToken,uploadImage } from "@/api/qiniu";
import { getPassport } from "@/libs/passport";
import { feeMethodOptions, orderStatusOptions, playerSignupFieldsLabel } from "@/config";
import PlayerForm from '@/components/PlayerForm'

Vue.use(Form).use(Field).use(Icon).use(Popup)
  .use(Loading).use(Overlay).use(Dialog).use(Uploader).use(RadioGroup)
  .use(Radio).use(Button).use(DatetimePicker).use(Picker).use(Cascader).use(Checkbox).use(CheckboxGroup)

const certTypeOption = [
  { value: 1, label: '身份证' },
  { value: 11, label: '学籍卡' },
  { value: 2, label: '护照' },
  { value: 3, label: '港澳通行证' },
  { value: 4, label: '台胞证' },
  { value: 5, label: '港澳台回乡证' }
]
// const certTypeColumns = ['身份证', '学籍卡', '护照', '港澳通行证', '台胞证', '港澳台回乡证']

export default {
  components: {
    PlayerForm
  },
  data() {
    return {
      showDialog: false,
      team: {},
      certTypeColumns: certTypeOption,
      showBirthday: false,
      showCertType: false,
      qiniuToken: '',
      players: [],
      player: {},
      project: {},
      minDate: '',
      maxDate: '',
      currentDate: '',
      defaultCertIndex: 0,
      options: [],
      fieldNames: {
        text: 'name',
        value: 'id',
        children: 'kids',
      },
      showArea: false,
      playerCheckboxes: {},
      allow: false,
      agreementList: [],
      showAgreement: false,
      title: '',
      unionMatchId: '',
      projectId: '',
      teamId: '',
      showSite: false,
      siteList: ['前锋', '中场', '后卫', '门将'],
      jerseysSizeObj: {},
      playerSignupFieldsLabel: playerSignupFieldsLabel,
      psfs: []
    }
  },
  mounted() {
    getPassport().then(res => {
      if (res) {
        this.unionMatchId = this.$route.query.unionMatchId
        this.projectId = this.$route.query.matchId
        this.teamId = this.$route.query.teamId
        this.getAreaTreeList()
        this.getQiniuUploadToken()
      }
    })
  },
  watch: {
    'player.IDCardNo': {
      handler() {
        if (RegExpr.isIdCard(this.player.IDCardNo)) {
          const player = JSON.parse(JSON.stringify(this.player))
          player.gender = '' + ToolUtil.getSex(player.IDCardNo)
          player.bmBirthdayValue = ToolUtil.getBirthday(player.IDCardNo)
          player.bmBirthday = DateUtil.parseDateTime(ToolUtil.getBirthday(this.player.IDCardNo), '{y}-{m}-{d}T00:00:00+0800')
          this.player = player
        }
      }
    },
    'player.gender': {
      handler() {
        if (this.playerCheckboxes.gender && (this.project.genderLimit != 0 && this.project.genderLimit != 3) && this.player.gender != this.project.genderLimit) {
          Toast({ type: 'fail', message: '性别异常' })
        }
      }
    }
  },
  methods: {
    getLabel(type) {
      const label = this.playerSignupFieldsLabel[type]
      return label
    },
    allowAgreement() {
      this.allow = true
      this.showAgreement = false
    },
    showAgreementFun() {
      this.showAgreement = true
      setTimeout(() => {
        const agreement = document.getElementById('agreement')
        let inner = ''
        this.agreementList.forEach(a => {
          inner += `<div style="background-color: #fff; padding: 12px 12px 0 12px;text-align: center;font-weight: 600;font-size: 24px;margin-bottom: 4px;">${a.title}</div>`
          inner += a.content
        })
        agreement.innerHTML = inner
      }, 0)
    },
    getPaymentStatus(value) {
      const order = orderStatusOptions.find(o => o.value === value)
      return order?.label || ''
    },
    getFeeMethodsLabel(value) {
      const item = feeMethodOptions.find(f => f.value === value)
      if (!item) return '--'
      return item.label
    },
    getAreaTreeList() {
      getAreaTreeList().then(res => {
        if (res) {
          const { data } = res
          this.options = JSON.parse(data.list.list.replaceAll("'", '"')) || []
          this.getBMMatchTeamSignup()
        }
      })
    },
    goEntryList() {
      this.$router.push('/entry-page/entry-list?unionMatchId=' + this.unionMatchId)
    },
    getBMMatchTeamSignup() {
      const params = {
        matchId: this.projectId
      }
      if (this.teamId) {
        params.teamId = this.teamId
      }
      getBMMatchTeamSignup(params).then(res => {
        if (res) {
          const data = res.data || {}
          const project = data.match
          this.agreementList = data.agreement || []
          const psfs = project.playerSignupFields && project.playerSignupFields.split('|') || []
          
          if (project.playerSignupFieldsLabel) {
            this.playerSignupFieldsLabel = {
              ...this.playerSignupFieldsLabel,
              ...project.playerSignupFieldsLabel,
            }
          }
          
          this.project = project
          this.team = data.team || {}

          // 处理证件类型过滤
          if (project.certTypeFields) {
            const certTypeFieldsArray = project.certTypeFields.split('|').map(Number)
            this.certTypeColumns = this.certTypeColumns.filter(item => certTypeFieldsArray.includes(item.value))
          }
          this.players = data.players || []
          this.psfs = psfs
        }
      })
    },
    getQiniuUploadToken() {
      getQiniuUploadToken({}).then(res => {
        this.qiniuToken = res.data.token
      })
    },
    savePlayer() {
      if (this.project.isUseAgreement === 1 && this.agreementList.length > 0 && !this.allow) {
        Toast.fail('请先同意协议或条款')
        return
      }
      if (this.playerCheckboxes.jerseysSize && !this.player.jerseysSize) {
        return Toast({ message: '请选择球衣尺码' })
      }
      this.$refs.playerForm.validate().then(() => {
        const params = JSON.parse(JSON.stringify(this.player))
        params.id = this.teamId
        params.matchId = this.projectId
        params.saveUser = 1

        if (!params.serialNumber) params.serialNumber = '_'
        delete params.avatarList
        delete params.IDCardPhotoAList
        delete params.IDCardPhotoBList
        delete params.bmBirthdayValue
        createBMMatchTeamPlayer(params).then(res => {
          if (res) {
            if (this.project.isOpenCharge === 1 && this.project.feeMethod === 1) {
              Dialog.confirm({
                title: '报名成功',
                message: '报名成功，请前往支付费用',
              }).then(() => {
                const params = {
                  matchId: this.projectId,
                  teamId: this.teamId,
                  playerId: res.data.id
                }
                const playerId = res.data.id
                bangsaishiCreatePlayerSignupOrder(params).then(res => {
                  if (res) {
                    this.$router.push(`/entry-page/payment?orderId=${res.data.orderId}&unionMatchId=${this.unionMatchId}&category=1&teamId=${this.teamId}&matchId=${this.projectId}&playerId=${playerId}`)
                  }
                })
              }).catch(() => {
                this.goEntryList()
              })
            } else {
              this.showDialog = true
            }
          }
        })
      })
    },
    getFormatDate(date) {
      if (!date) return ''
      return DateUtil.parseDateTime(date, '{y}-{m}-{d}')
    },
    confirmBirthdayTime(value) {
      this.player.bmBirthdayValue = DateUtil.parseDateTime(value, '{y}-{m}-{d}')
      this.player.bmBirthday = DateUtil.parseDateTime(value, '{y}-{m}-{d}T00:00:00+0800')
      this.showBirthday = false
    },
    cancelBirthdayTime() {
      this.showBirthday = false
    },
    onChange({ selectedOptions }) {
      const a = []
      selectedOptions.forEach(item => {
        a.push(item.name)
      })
      this.player.domicileAreaName = a.join('/')
      console.log(this.player.domicileAreaName, this.player.domicileAreaId)
    },
    onFinish({ selectedOptions }) {
      const a = []
      selectedOptions.forEach(item => {
        a.push(item.name)
      })
      this.player.domicileAreaName = a.join('/')
      this.showArea = false
    },
    showCertTypeFun() {
      this.showCertType = true
    },
    onConfirmCertType(value) {
      this.player.certTypeValue = value.label
      this.player.certType = value.value
      this.showCertType = false
    },
    onCancelCertType() {
      const index = this.roleColumns.findIndex(item => item === this.player.certTypeValue)
      this.defaultCertIndex = index > -1 ? index : 0
      this.showCertType = false
    },
    uploadAvatar(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.player.avatar = res.hash
      })
    },
    deleteAvatar() {
      this.player.avatar = this.team.avatarList.join(',') ?? ''
    },
    uploadIDCardPhotoA(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.player.IDCardPhotoA = res.hash
      })
    },
    deleteIDCardPhotoA() {
      this.player.IDCardPhotoA = this.team.IDCardPhotoAList.join(',') ?? ''
    },
    uploadIDCardPhotoB(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.player.IDCardPhotoB = res.hash
      })
    },
    deleteIDCardPhotoB() {
      this.player.IDCardPhotoB = this.team.IDCardPhotoBList.join(',') ?? ''
    },
    uploadQualificationFile(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        const player = JSON.parse(JSON.stringify(this.player))
        if (player.qualificationFile && player.qualificationFile.length > 0) {
          player.qualificationFile = player.qualificationFile + ',' + res.hash
        } else {
          player.qualificationFile = res.hash
        }
        const a = player.qualificationFile.split(',')
        player.qualificationFileList = []
        a.forEach(item => {
          player.qualificationFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item },)
        })
        this.player = player
      })
    },
    deleteQualificationFile() {
      const player = JSON.parse(JSON.stringify(this.player))
      const a = []
      player.qualificationFileList.forEach(item => {
        a.push(item.hash)
      })
      player.qualificationFile = a.join(',')
      this.player = player
    },
    uploadInsureFile(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        const player = JSON.parse(JSON.stringify(this.player))
        if (player.insureFile && player.insureFile.length > 0) {
          player.insureFile = player.insureFile + ',' + res.hash
        } else {
          player.insureFile = res.hash
        }
        const a = player.insureFile.split(',') || []
        player.insureFileList = []
        a.forEach(item => {
          player.insureFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item },)
        })
        this.player = player
      })
    },
    deleteInsureFile() {
      const player = JSON.parse(JSON.stringify(this.player))
      const a = []
      player.insureFileList.forEach(item => {
        a.push(item.hash)
      })
      player.insureFile = a.join(',')
      this.player = player
    }
  }
}
</script>

<style lang="scss">
.wx-invite {
  padding-bottom: 30px;

  .notice {
    display: flex;
    align-items: center;
    height: 32px;
    font-size: 11px;
    background-color: #FEF8F6;
    color: #FF652A;
    padding: 0 8px;

    .info {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .team-info {
    padding: 12px;
    background-color: #F8F8F8;
    border-radius: 4px;

    .name {
      font-size: 16px;
      line-height: 30px;
      color: #333333;
    }

    .group {
      font-size: 14px;
      line-height: 30px;
      color: #8d8d8d;
    }

    .player-num {
      font-size: 14px;
      line-height: 30px;
      color: #333333;
    }
  }

  .project {
    padding: 16px 12px 12px 12px;
    margin-bottom: 12px;
    background-color: #F8F8F8;
    border-radius: 4px;

    .top {
      display: flex;
      justify-content: space-between;

      .left {
        .group {
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;

          .entryType {
            background-color: #FF652A;
            color: #FFFFFF;
            border-radius: 2px;
            display: inline-block;
            height: 20px;
            width: 32px;
            line-height: 20px;
            font-size: 12px;
            text-align: center;
          }

          .group-name {
            font-size: 16px;
            height: 20px;
            color: #333333;
          }
        }

        .row {
          display: flex;
          align-items: center;
          padding: 0 0 5px 0;

          .base-box {
            width: 20px;
            height: 20px;
            background-color: #FBEFEA;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .info {
            font-size: 12px;
            color: #8C8C8C;
          }

          .col {
            display: flex;
            height: 20px;
            width: 82px;
            line-height: 20px;

            .icon {
              width: 20px;
              height: 20px;
              text-align: center;
              line-height: 20px;
              background-color: #1565FC;
              font-size: 12px;
              font-weight: 500;
              color: #FFFFFF;
            }
          }
        }
      }

      .right {
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .line {
      margin: 4px 0 10px 0;
      height: 1px;
      background-color: #F3F3F3;
    }

    .bottom1 {
      .row {
        display: flex;
        justify-content: space-between;

        .base-box {
          width: 20px;
          height: 20px;
          background-color: #FBEFEA;
          border-radius: 2px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .info {
          font-size: 12px;
          color: #8C8C8C;
        }

        .col {
          display: flex;
          height: 20px;
          line-height: 20px;

          .icon {
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            background-color: #1565FC;
            font-size: 12px;
            font-weight: 500;
            color: #FFFFFF;
          }

          .price {
            height: 20px;
            width: 68px;
            text-align: center;
            line-height: 20px;
            background-color: #E5EDFF;
            font-size: 12px;
            font-weight: 500;
            color: #1565FC;
            border-radius: 0 3px 3px 0;
          }

          .num {
            font-size: 14px;
            color: #8C8C8C;
          }
        }
      }
    }
  }

  .title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 15px;
    color: #333333;
    padding: 25px 0 13px 0;
    margin: 0 16px;
    border-bottom: 0.5px #EEEEEE solid;

    .icon {
      width: 2px;
      height: 12px;
      background-color: #7CCD19;
      margin-right: 6px;
    }
  }

  .bottom {
    position: fixed;
    bottom: 0;
    width: 100vw;
    padding: 14px 12px 12px 12px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }
}

.agreement-top {
  background-color: #fff;
  padding: 12px 12px 0 12px;

  .agreement-title {
    text-align: center;
    font-weight: 600;
    font-size: 24px;
    margin-bottom: 4px;
  }

  .hint {
    text-align: center;
    font-size: 16px;
    color: #8C8C8C;
  }
}

#agreement {
  padding: 0 24px 12px 24px;

  .wscnph {
    width: 100%;
  }
}

::v-deep .my-imgs {
  width: 100%;
}
</style>
